<template>
  <div>
    <v-tabs light>
        <v-tabs-slider color="light-blue lighten-2"></v-tabs-slider>
        <v-tab href="#tab-1">Show Login User Profile</v-tab>
        <v-tab href="#tab-2">Edit Login User Profile</v-tab>
        <v-tab href="#tab-3" v-if="this.shouldDisplay('/reSetPwd')">Reset Login User Password</v-tab>
        <v-tab-item :id="'tab-1'">
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field box label="Login Email Address" v-model="user.loginEmailAddress"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Status" v-model="user.userStatus"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="First Name" v-model="user.firstName"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Last Name" v-model="user.lastName"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Phone Number" v-model="phonenum"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Page Number" v-model="pagernum"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Care Group" v-model="groupname"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Account Type" v-model="accttype"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Last Longin At" v-model="user.lastLoginAt"></v-text-field>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item :id="'tab-2'">
          <v-card flat>
            <v-card-text class="text-xs-left">
              To Edit Login User Profile Details
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :id="'tab-3'" v-if="this.shouldDisplay('/reSetPwd')">
          <v-form v-model="valid">
            <v-card>
              <v-card-text>Reset Password for {{user.firstName}} {{user.lastName}}</v-card-text>
              <v-card-text>
                <br>
                  <div class="red--text" v-html="error"></div>
                <br>
                <v-btn @click="resetpwd">Reset User Password</v-btn>
              </v-card-text>
            </v-card>
          </v-form>
        </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import mixins from '@/mixins.js'
import LoginUserService from '@/services/LoginUserService'

export default {
  data () {
    return {
      id: 0,
      groupname: '',
      accttype: '',
      phonenum: '',
      pagernum: '',
      user: null,
      error: null
    }
  },
  mixins: [mixins],
  async mounted () {
    try {
      this.error = null
      this.id = this.$route.params.id;
      const response =  await LoginUserService.show({
        userid: this.$route.params.id
      })
      this.user = response.data
      if(this.user.careGroup) {
        this.groupname = this.user.careGroup.name
      }
      if(this.user.userAccountType) {
        this.accttype = this.user.userAccountType.description
      }
      if(this.user.phone) {
        this.phonenum = this.user.phone.phone
      }
      if(this.user.pager) {
        this.pagernum = this.user.pager.pagerNumber
      }
    } catch (error) {
      this.error = this.handleError(error)
    }
  },
  methods: {
    async resetpwd () {
      try {
        const response = await LoginUserService.resetpwd({
          userid: this.user.loginId
        })
        this.error = 'Reset Password Successful'
        this.$router.push({
          name: 'loginUserEdit'
        })
      } catch (error) {
        this.error = this.handleError(error)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LoginUserEdit.vue